<template>
    <div class="page">
    <ion-grid>
      <ion-row class="search-view">
        <ion-col>
          <ion-row align-items-stretch>
             <ion-col size="12" size-md="2">
              <ion-label>Corporate Name</ion-label>
              <div class="border-line-34 readonly margin-top-10">
                <ion-input
                  class="form-input"
                  type="text"
                  id="corporateName"
                  @input="corporateName = $event.target.value"
                  :value="corporateName"
                  maxlength="100"
                  readonly = true
                ></ion-input>
              </div>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>Branch Name</ion-label>
              <div class="border-line-34 readonly margin-top-10">
                <ion-input
                  class="form-input"
                  type="text"
                  id="branch"
                  @input="branch = $event.target.value"
                  :value = "branchName"
                  maxlength="100"
                  readonly = true
                ></ion-input>
              </div>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>Mobile Number</ion-label>
              <div class="border-line-34 margin-top-10">
                <ion-input
                  class="form-input"
                  type="text"
                  id="mobileOrEmail"
                  @input="mobileOrEmail = $event.target.value"
                  maxlength="100"
                ></ion-input>
              </div>
            </ion-col>
            <!-- <ion-col size="12" size-md="2">
              <ion-label>Email ID</ion-label>
              <div class="border-line-34 margin-top-10">
                <ion-input
                  class="form-input"
                  type="text"
                  id="emailId"
                  @input="emailId = $event.target.value"
                  maxlength="100"
                ></ion-input>
              </div>
            </ion-col> -->
             <ion-col size="12" size-md="2">
              <ion-label>Status</ion-label>
              <div class="border-line-34 margin-top-10">
                <ion-select
                  class="form-select select-mobile"
                  id="status"
                  :value="status"
                  @ionChange="status = $event.target.value"
                  placeholder="Select Status"
                  interface="action-sheet"
                >
                  <ion-select-option
                    v-for="(status, index) in this.statuses"
                    :key="index"
                    :value="status.id"
                  >{{status.name}}</ion-select-option>
                </ion-select>

                <select
                  class="input-select select-web"
                  v-model="status"
                  placeholder="Select Status"
                >
                  <option
                    v-for="(status, index) in this.statuses"
                    :key="index"
                    :value="status.id"
                  >{{ status.name }}</option>
                </select>
              </div>
            </ion-col>
             <ion-col size="12" size-md="2">
              <ion-label>Tariff Type</ion-label>
              <div class="border-line-34 margin-top-10">
                <ion-select
                  class="form-select select-mobile"
                  id="tariffType"
                  :value="tariffType"
                  @ionChange="tariffType = $event.target.value"
                  placeholder="Select Status"
                  interface="action-sheet"
                >
                  <ion-select-option
                    v-for="(tariff, index) in this.tariffTypes"
                    :key="index"
                    :value="tariff.id"
                  >{{tariff.name}}</ion-select-option>
                </ion-select>

                <select
                  class="input-select select-web"
                  v-model="tariffType"
                  placeholder="Select Status"
                >
                  <option
                    v-for="(tariff, index) in this.tariffTypes"
                    :key="index"
                    :value="tariff.id"
                  >{{ tariff.name }}</option>
                </select>
              </div>
            </ion-col>
            <ion-col size="12" size-md="2">
              <br />
              <ion-button class="btn-search margin-top-10" @click="searchUserBrancheRelationship">Search</ion-button>
              <ion-button class="btn-clear margin-top-10" @click="clearFields">
                <ion-icon :icon="refresh"></ion-icon>
              </ion-button>
            </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>
      <ion-row class="row-divider"></ion-row>
      <ion-row class="list-view">
        <ion-col>
          <ion-row class="list-head">
             <ion-col size="12" size-md="1">
              <ion-label>UserID</ion-label>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>First Name & Last Name</ion-label>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>Mobile Number</ion-label>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>Tariff Type</ion-label>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>Effective From</ion-label>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>Last Effective Date</ion-label>
            </ion-col>
            <ion-col size="12" size-md="1">
              <ion-label>Status</ion-label>
            </ion-col>
            <!-- <ion-col size="12" size-md="2">
              <ion-label>Delete</ion-label>
            </ion-col> -->
          </ion-row>
          <hr />

          <ion-row class="list-item" v-for="(corporate) in this.corporates" :key="corporate">
            <ion-col size="12" size-md="1">
              <ion-label class="ext-link" @click="viewManageUser(corporate)">{{corporate.userId}}</ion-label>
            </ion-col>
            
            <ion-col size="12" size-md="2" style="cursor: pointer;" @click="addMobileNoInFilter(corporate.email)">
              <ion-label>{{corporate.name}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="2" style="cursor: pointer;" @click="addMobileNoInFilter(corporate.email)">
              <ion-label>{{corporate.email}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>{{corporate.tariffType.description}}</ion-label>
            </ion-col>
            <ion-col size="12" size-md="2">
              <ion-label>{{changeDateFormatWithoutTime(corporate.effectiveDate)}}</ion-label>
            </ion-col>
           
            <ion-col size="12" size-md="2">
              <ion-label>{{changeDateFormatWithoutTime(corporate.lastEffectiveDate)}}</ion-label>
            </ion-col>
            
            <ion-col size="12" size-md="1">
              <ion-label v-bind:class="[{'active': corporate.status.code == 'A'}, {'in-active': corporate.status.code == 'I'}]">{{convertUppercase(corporate.status.description)}}</ion-label>
            </ion-col>
            <!-- <ion-col size="12" size-md="2">
              <ion-icon :icon="trash" class="ext-link create-trash-icon customIcon" v-if="corporate.status.code == 'A'" @click="deleteUser(corporate)"></ion-icon> -->
              <!-- <ion-label class="ext-link in-active" v-if="corporate.status.code == 'A'" @click="deleteUserFromBranch(corporate)">{{corporate.status.code == "A" ? "Delete" : "" | uppercase}}</ion-label> -->
            <!-- </ion-col> -->
          </ion-row>
        </ion-col>
      </ion-row>
      <ion-row class="row-divider"></ion-row>
      <ion-row v-if="norecordsfound">
        <ion-col size="12" class="ion-text-center">
          <ion-label class="pagination-info">No records found for the selected filters</ion-label>
        </ion-col>
      </ion-row>
      <ion-row v-else>
        <ion-col size="12" size-md="5">
          <ion-label
            class="pagination-info"
          >Showing {{((pageRecords * pageNo) <= totalRecords) ? (pageRecords * pageNo) : totalRecords}} of {{totalRecords}} results</ion-label>
        </ion-col>
        <ion-col size="12" size-md="7" class= "ion-text-right">
          <!-- In a tag removed href="#" because of navigation issue -->
          <div class="pagination">
            <a  class="prev" v-if="this.pageNo > 1" @click="loadPage(pageNo - 1)">Prev</a>
            <a  class="prev disabled" v-else>Prev</a>
            <a
              
              v-for="page in this.pagesList"
              :key="page"
              v-bind:class="{'active': pageNo == page}"
              @click="loadPage(page)"
            >{{page}}</a>
            <a
              
              class="next"
              v-if="this.pageNo < this.totalPages"
              @click="loadPage(pageNo + 1)"
            >Next</a>
            <a  class="next disabled" v-else>Next</a>
          </div>
          
        </ion-col>
      </ion-row>
    </ion-grid>
    <div class="spinner">
      <ion-spinner v-if="loaderTab"></ion-spinner>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { refresh, trash } from 'ionicons/icons';
import { PaginationUtils } from "../../util/pagination-utils";
// import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
import datepicker from 'vue3-datepicker';
import { CorporateService } from "../../service/corporate/corporate.service";
import { IonButton, IonCol, IonGrid, IonIcon, IonInput, IonLabel, IonRow, IonSelect, IonSelectOption, IonSpinner, alertController } from "@ionic/vue";
import moment from "moment";
import { migratedTryParseServiceError } from "../../service";
import { ToastUtils } from "../../util/toast-utils";

export default defineComponent ({
  name: 'manageUserToBranches',
  components: {
    datepicker, IonGrid, IonRow, IonCol, IonLabel, IonInput, IonSelect, IonSelectOption, IonButton, IonIcon, IonSpinner, alertController
  },
  data() {
    return {
      refresh,  
      trash,
      loaderTab: true,
      previousValue: false,
      corporates: [],
      statuses: [],
      corporateId: "",
      corporateName: "",
      branchId: "",
      branchName: "",
      mobileOrEmail: "",
      userId: "",
      status: "",
      norecordsfound: true,
      totalRecords: 0,
      pageRecords: 15,
      pageNo: 1,
      pagesList: [],
      totalPages: 0,
      tariffTypes: [],
      tariffType: ""
    }
  },
  async mounted() {
    this.getTariffType();
    localStorage.removeItem("manageUser") 
    let branchInfo = JSON.parse(localStorage.getItem('branchInfo'));
    if(!this.$route.params.corporateId && branchInfo) {
      let corporateDetails = await new CorporateService().getBranchDetailsById(branchInfo.branchId);
      this.loaderTab = false;
      this.fillCorporateDetails(corporateDetails);

      let page = localStorage.getItem('userBranchPage');
      if (page) {
        this.pageNo = Number(page);
      }

      var search = localStorage.getItem('manageUserSearch');
      if (search) {
        search = JSON.parse(search);
        this.mobileOrEmail = search.mobileOrEmail;
        this.status = search.status;
        this.tariffType = search.tariffType;
        document.getElementById("mobileOrEmail").value = search.mobileOrEmail;
        document.getElementById("status").value = search.status;
        document.getElementById("tariffType").value = search.tariffType;
        await this.searchUserBrancheRelationship();
      }
      this.searchUserBrancheRelationship()
    }
    this.statuses = await new CorporateService().getUserBranchRelationshipStatus();

    

    // try {
    //   alert('240 '+ this.$route.params.corporateId)
    //   if (this.$route.params.corporateId) {
    //     alert('242')
    //   let corporateDetails = await new CorporateService().getBranchDetailsById(
    //     this.$route.params.corporateId
    //   );
    //   this.fillCorporateDetails(corporateDetails);
    //   }
    //   let branchInfo = JSON.parse(localStorage.getItem('branchInfo'));
    //   alert('249 ' + branchInfo)
    //   if(!this.$route.params.corporateId && branchInfo) {
    //     alert('251')
    //     let corporateDetails = await new CorporateService().getBranchDetailsById(branchInfo.branchId);
    //     this.fillCorporateDetails(corporateDetails);
    //   }
    //   this.statuses = await new CorporateService().getUserBranchRelationshipStatus();
    //   var page = localStorage.getItem('userBranchPage');
    //   if(page) {
    //     this.pageNo = Number(page);
    //   }
    //   // await this.searchUserBrancheRelationship();
    //   var search = JSON.parse(localStorage.getItem('userBranchSearch'));
    //   alert('258'+ search)
    //   if(search) {
    //     this.branchId = search.branchId;
    //     this.corporateName = search.corporateName;
    //     this.branchName = search.branchName;
    //     await this.searchUserBrancheRelationship();
    //   } else {
    //     await this.searchUserBrancheRelationship();
    //   }
    //   this.loaderTab = false;
    // } catch(error) {
    //   this.loaderTab = false;
    //   let serviceError = migratedTryParseServiceError(error);
    //   new ToastUtils().presentToast(serviceError.description);
    // }
  },
  methods: {
    addMobileNoInFilter(name) {
      document.getElementById('mobileOrEmail').value = name;
      this.mobileOrEmail = name;
    },
    async getTariffType() {
      this.tariffTypes = await new CorporateService().getUserTypes(); 
    },
    viewManageUser(val) {
      localStorage.setItem("manageUser", JSON.stringify(val))
      this.$router.push("associateUserToBranch")
    },
    changeDateFormat(dateValue) {
      return moment(dateValue).format('DD/MMM/YYYY HH:mm')
    },
    changeDateFormatWithoutTime(dateValue) {
      
      if(dateValue != null) {
        return moment(dateValue).format('DD/MMM/YYYY')
      }
      
    },
    convertUppercase(value) {
        return value.toUpperCase()
      },
    viewBranchDetails(corporateId) {
      this.$router.push({
        name: "userBranchRelationshipDetails",
        params: { branchId: this.$route.params.corporateId }
      });
    },
    fillCorporateDetails(corporateInfo) {
        this.corporateName = corporateInfo.corporateName;
        this.branchName = corporateInfo.branch;
        this.branchId = corporateInfo.branchId;
        this.userId = corporateInfo.userId;
    },
    clearFields() {
      document.getElementById("mobileOrEmail").value = null;
      this.mobileOrEmail = "";
      this.status = null;
      this.tariffType = "";
      localStorage.removeItem('userBranchSearch');
      localStorage.removeItem('userBranchPage');
      this.corporates = [];
      this.norecordsfound = true;
    },

    async searchUserBrancheRelationship() {
      let existingFilterData = JSON.parse(localStorage.getItem("manageUserSearch"))
      let searchFilterData = {
          mobileOrEmail: this.mobileOrEmail,
          status: this.status,
          tariffType: this.tariffType
        }
        if(!this.areFiltersEqual(searchFilterData, existingFilterData)) {
         localStorage.setItem("manageUserSearch",JSON.stringify(searchFilterData));
          this.pageNo = 1;
          localStorage.setItem('userBranchPage', this.pageNo);
        } else {
          let pageNo = localStorage.getItem('userBranchPage');
          if(pageNo) {
            this.pageNo = pageNo;
          } else {
            this.pageNo = 1;
          }
        }
        localStorage.setItem("manageUserSearch",JSON.stringify(searchFilterData));
      try {
        // this.pageNo = 1;
        // localStorage.setItem("userBranchSearch", JSON.stringify({corporateName: this.corporateName, branchId: this.branchId,  branchName: this.branchName}))
        this.loaderTab = true;
        let result = await new CorporateService().userBranchRelationshipAtPageByPaginatedWithSizeMatchingQuery(
          this.pageNo,
          this.pageRecords,
          {
            id: this.branchId,
            mobileOrEmail: this.mobileOrEmail,
            status: this.status,
            tariffType: this.tariffType
          }
        );
        if(result.data.length != 0) {

          this.totalRecords = result.meta.totalrecords;
          this.corporates = result.data;
          // console.log("type" + JSON.stringify(this.corporates))
          (this.pagesList = new PaginationUtils().getPagesList(
            this.totalRecords,
            this.pageRecords,
            this.pageNo
          )),
          (this.totalPages = new PaginationUtils().getTotalPages(
            this.totalRecords,
            this.pageRecords
          ));
          this.norecordsfound = false;
          this.loaderTab = false;
        } else {
          this.corporates = [];
          // this.mobileOrEmail = "";
          // document.getElementById("mobileOrEmail").value = null;
          // this.status = null;
          this.norecordsfound = true;
          this.loaderTab = false;
        }
      } catch(error) {
        this.loaderTab = false;
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      }
     
    },
    areFiltersEqual(a, b) {
      return JSON.stringify(a) === JSON.stringify(b);
    },
    async loadPage(page) {
      localStorage.setItem('userBranchPage', page);
      let existingFilterData = JSON.parse(localStorage.getItem("manageUserSearch"))
      let searchFilterData = {
          mobileOrEmail: this.mobileOrEmail,
          status: this.status,
          tariffType: this.tariffType
        }
        if(!this.areFiltersEqual(searchFilterData, existingFilterData)) {
         localStorage.setItem("manageUserSearch",JSON.stringify(searchFilterData));
          this.pageNo = 1;
          localStorage.setItem('userBranchPage', this.pageNo);
        } else {
          let pageNo = localStorage.getItem('userBranchPage');
          if(pageNo) {
            this.pageNo = pageNo;
          } else {
            this.pageNo = 1;
          }
        }
        localStorage.setItem("manageUserSearch",JSON.stringify(searchFilterData));
      this.loaderTab = true;
      // this.pageNo = page;
      this.pagesList = new PaginationUtils().getPagesList(
        this.totalRecords,
        this.pageRecords,
        page
      );
       let result = await new CorporateService().userBranchRelationshipAtPageByPaginatedWithSizeMatchingQuery(
        this.pageNo,
        this.pageRecords,
        {
          id: this.branchId,
          mobileOrEmail: this.mobileOrEmail,
          status: this.status,
          tariffType: this.tariffType
        }
      );
      if(result.data.length != 0) {

        this.totalRecords = result.meta.totalrecords;
        this.corporates = result.data;
        (this.pagesList = new PaginationUtils().getPagesList(
          this.totalRecords,
          this.pageRecords,
          this.pageNo
        )),
        (this.totalPages = new PaginationUtils().getTotalPages(
          this.totalRecords,
          this.pageRecords
        ));
        this.norecordsfound = false;
        this.loaderTab = false;
      } else {
        this.corporates = [];
        document.getElementById("mobileOrEmail").value = null;
        this.status = null;
        this.norecordsfound = true;
        this.loaderTab = false;
      }
     
    },
    async deleteUser(branchInfo) {
      const alert = await alertController.create({
        header: "Confirm",
        message: "Are you sure you want to remove this user?",
        buttons: [
          {
            text: "NO",
            role: "cancel",
            cssClass: "secondary",
            handler: () => {
            }
          },
          {
            text: "YES",
            handler: () => {
              this.deleteUserFromBranch(branchInfo);
            }
          }
        ]
      });

      await alert.present();

      // const alert = document.createElement("ion-alert");
      // alert.header = "Confirm";
      // alert.message = "Are you sure you want to remove this user?";
      // alert.buttons = [
      //   {
      //     text: "NO",
      //     role: "cancel",
      //     cssClass: "secondary",
      //     handler: () => {}
      //   },
      //   {
      //     text: "YES",
      //     handler: () => {
      //       this.deleteUserFromBranch(branchInfo);
      //     }
      //   }
      // ];
      // document.body.appendChild(alert);
      // return alert.present();
    },
    async deleteUserFromBranch(branchInfo) {
      
      let result =  await new CorporateService().deleteUserFromBranchRelationship(
        branchInfo.branchId,
        branchInfo.userId,
        this.pageNo,
        this.pageRecords,
      );
      if(result.data.length != 0) {
        this.totalRecords = result.meta.totalrecords;
        this.corporates = result.data;
        (this.pagesList = new PaginationUtils().getPagesList(
          this.totalRecords,
          this.pageRecords,
          this.pageNo
        )),
        (this.totalPages = new PaginationUtils().getTotalPages(
          this.totalRecords,
          this.pageRecords
        ));
        this.norecordsfound = false;
        this.loaderTab = false;
      } else {
        this.corporates = [];
        this.norecordsfound = true;
        this.loaderTab = false;
      }
    }
  }
})
</script>

<style scoped>
.readonly {
  background: #f8f8f8 0% 0% no-repeat padding-box;
}
.select-box {
  position: relative;
  max-width: 317px;
  width: 100%;
  display: inline-block;
  margin-right: 16px;
}

.select-box ion-select {
  max-width: 317px;
  width: 100%;
  height: 34px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #0000001a;
  border-radius: 4px;
  opacity: 1;
  padding: 12px;
  padding-top: 13px;
  text-align: left;
  font-size: 14px;
  font-family: "Roboto Medium";
  letter-spacing: 0;
  line-height: 26px;
  color: #202020;
}

.select-box .custom-select-placeholder {
  font-size: 14px;
  font-family: "Roboto Medium";
  letter-spacing: 0;
  color: #202020;
  opacity: 1;
  position: absolute;
  z-index: 99;
  top: 18px;
  left: 18px;
}

.select-box .custom-select-icon {
  position: absolute;
  z-index: 99;
  top: 6px;
  background: #fff;
  right: 15px;
}
.customIcon{
  font-size: 1.3rem;
  color: gray;
}
</style>